'use client';

import { Tile, Spinner, SectionTitle } from 'mode-shared/components';
import { CalendarIcon } from 'mode-shared/icons';
import { useGovernanceCalendar } from 'mode-shared/hooks/content/hooks/useGovernanceCalendar';
import { useMemo } from 'react';
import { isFuture, format } from 'date-fns';
import { GovernanceCalendarDay } from 'mode-shared/hooks/content/hooks/useGovernanceCalendar';

export const GovernanceCalendar = () => {
  const { data: calendarItems, isLoading: isCalendarLoading } = useGovernanceCalendar();
  const preparedDates = useMemo(() => {
    return calendarItems?.filter((item) => isFuture(item.date)).slice(0, 4) || [];
  }, [calendarItems]);

  if (!preparedDates.length && !isCalendarLoading) return null;

  return (
    <Tile>
      <SectionTitle>
        <CalendarIcon className="w-4 h-4" />
        Governance calendar
      </SectionTitle>
      {isCalendarLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col lg:flex-row gap-x-6 gap-y-2 overflow-x-auto">
          {preparedDates.map((day) => (
            <GovernanceCalendarItem {...day} key={day.eventName} />
          ))}
        </div>
      )}
    </Tile>
  );
};

export const GovernanceCalendarItem = ({ eventName, date, color }: GovernanceCalendarDay) => {
  const dayOfWeek = format(date, 'EE');
  const dayOfMonth = format(date, 'd');
  const time = format(date, 'HH:mm');

  return (
    <div
      className="flex flex-row items-center py-1 pr-3 border-left border-l-2 bg-neutral-950 gap-x-2 w-full"
      style={{ borderColor: color }}
    >
      <div className="flex flex-col items-center px-2 font-bold">
        <p className="uppercase">{dayOfWeek}</p>
        <p className="text-2xl">{dayOfMonth}</p>
      </div>
      <div className="flex flex-col gap-y-2">
        <p className="text-white font-semibold text-nowrap font-sans">{eventName}</p>
        <p className="text-sm text-grey-400 font-bold">{time} UTC</p>
      </div>
    </div>
  );
};
